/* ================================================================
   BASMADAN ONCE CEK:  shopify theme pull --live --only assets/theme.js

   Bu dosyaya birden fazla kisi basiyor; bayat kopyadan push baskasinin
   isini sessizce siliyor.

   PEMBE SCROLL EFEKTINI GERI GETIRME. Eski pembe kimlikten kalma, body
   arka planini kaydirdikca kremden pembeye boyayan blok (P=[247,184,212]).
   Iki kez silindi, iki kez geri geldi. Urun sayfasinda yerine
   yuso-pilot.css'teki statik degrade var.

   Push'tan sonra:  bash ~/Desktop/ENDORA/yuso-kontrol.sh
   ================================================================ */
/* Endora tema betigi: sepet, arama, slider, cekmeceler, hesap */

function sw(s,el){document.getElementById('mainimg').src=s;document.querySelectorAll('.pdp-gallery__thumb').forEach(t=>t.classList.remove('is-active'));el.classList.add('is-active');}
function authTab(el,ad){
  var hedef = ad || (el && el.getAttribute('data-panel')) || 'login';
  document.querySelectorAll('.auth-form').forEach(function(f){ f.classList.toggle('is-active', f.id==='panel-'+hedef); });
  document.querySelectorAll('.auth-tab').forEach(function(t){ t.classList.toggle('is-active', t.getAttribute('data-panel')===hedef); });
  var b=document.getElementById('authTitle');
  if(b) b.textContent = hedef==='register' ? 'Yeni Hesap' : (hedef==='forgot' ? 'Şifre Sıfırlama' : 'Giriş Yap');
  return false;
}
function authDemo(e){ e.preventDefault(); var n=document.getElementById('authNote'); if(n) n.hidden=false; return false; }
/* ---- onizleme sepeti (localStorage) ---- */
var SEPET_ANAHTAR='endora_sepet';
function sepetOku(){ try{ return JSON.parse(localStorage.getItem(SEPET_ANAHTAR)||'[]'); }catch(e){ return []; } }
function sepetYaz(v){ try{ localStorage.setItem(SEPET_ANAHTAR, JSON.stringify(v)); }catch(e){} sepetCiz(); }
function sepetAdet(){ return sepetOku().reduce(function(t,x){ return t+(x.adet||1); },0); }
function fiyatYaz(n){ return '₺'+Number(n).toLocaleString('tr-TR')+',00'; }
function sepeteEkle(h,ad,fiyat,gorsel){
  var v=sepetOku(), bulundu=false;
  v.forEach(function(x){ if(x.h===h){ x.adet=(x.adet||1)+1; bulundu=true; } });
  if(!bulundu) v.push({h:h,ad:ad,fiyat:fiyat,gorsel:gorsel,adet:1});
  sepetYaz(v);
  sepetBildir(ad+' sepete eklendi');
  var d=document.getElementById('bagDrawer'); if(d && !d.classList.contains('open')) d.classList.add('open');
  return false;
}
function sepettenCikar(h){ sepetYaz(sepetOku().filter(function(x){ return x.h!==h; })); }
function sepetBildir(mesaj){
  var t=document.getElementById('bagToast');
  if(!t){ t=document.createElement('div'); t.id='bagToast'; t.className='bag-toast'; document.body.appendChild(t); }
  t.textContent=mesaj; t.classList.add('is-on');
  clearTimeout(t._z); t._z=setTimeout(function(){ t.classList.remove('is-on'); }, 2200);
}
function sepetCiz(){
  var v=sepetOku(), adet=sepetAdet();
  /* Bu sepet localStorage'da tutulan ONIZLEME sepeti; Shopify'in gercek
     sepetiyle alakasi yok. Header gercek sayaci yonetiyorsa (canli tema)
     rozete DOKUNMA -- yoksa sunucudan gelen dogru sayiyi yanlis bir
     degerle ve rozete sigmayan bir metinle eziyordu (2 Eyl). */
  if (!window.yusoSayaclariYaz) {
    document.querySelectorAll('[data-bag-count], .hdr-drawer__cart').forEach(function(el){
      el.textContent='Sepet ('+adet+')';
    });
  }
  var govde=document.getElementById('bagBody');
  if(!govde) return;
  if(!v.length){
    govde.innerHTML='<p class="bag-drawer__msg">Sepetiniz boş. Cilt bakımı rutinine başlamanın tam zamanı.</p>'+
      '<a href="products.html" class="bag-drawer__btn">Alışverişe Devam Et</a>';
    return;
  }
  var toplam=0, satirlar='';
  v.forEach(function(x){
    toplam += (x.fiyat||0)*(x.adet||1);
    satirlar += '<div class="bag-line"><span class="bag-line__img"><img src="'+x.gorsel+'" alt="'+x.ad+'"></span>'+
      '<span class="bag-line__txt"><span class="bag-line__name">'+x.ad+'</span>'+
      '<span class="bag-line__meta">'+(x.adet||1)+' adet · '+fiyatYaz((x.fiyat||0)*(x.adet||1))+'</span></span>'+
      '<button class="bag-line__rm" aria-label="Ürünü çıkar" onclick="sepettenCikar(&quot;'+x.h+'&quot;)">×</button></div>';
  });
  govde.innerHTML = satirlar +
    '<div class="bag-total"><span>Ara Toplam</span><span>'+fiyatYaz(toplam)+'</span></div>'+
    '<p class="bag-line__meta" style="width:100%;text-align:left">'+(toplam>=500?'Kargo ücretsiz.':'500 TL üzeri kargo ücretsiz.')+'</p>'+
    '<div class="bag-actions"><button class="btn btn--block" onclick="sepetBildir(&quot;Ödeme adımı mağaza yayına alındığında açılacak&quot;)">Ödemeye Geç</button>'+
    '<a href="products.html" class="bag-drawer__btn">Alışverişe Devam Et</a></div>';
}
document.addEventListener('DOMContentLoaded', sepetCiz);
window.addEventListener('storage', sepetCiz);

/* ---- arama ---- */
function aramaAc(){
  var k=document.getElementById('searchLayer'); if(!k) return;
  k.classList.add('open');
  var g=document.getElementById('searchInput'); if(g){ g.value=''; g.focus(); } /* focus inside the tap itself: iOS only opens the keyboard then */
  var s=document.getElementById('searchResults'); if(s) s.innerHTML='';
  var h=document.getElementById('searchHint'); if(h) h.hidden=false;
}
function aramaKapat(){ var k=document.getElementById('searchLayer'); if(k) k.classList.remove('open'); }
/* aramaYap() ve ARAMA_VERISI kaldirildi (guvenlik).
   Statik onizleme surumuydu: arama metnini ve urun adlarini hic kacirmadan
   innerHTML'e yaziyordu. Hicbir yer cagirmadigi icin istismar edilemiyordu,
   ama bu dosya defer ile yuklendigi icin global aramaYap'i guvenli surumun
   uzerine yaziyordu; biri onu tekrar bir input'a baglasa aninda XSS olurdu.
   Gercek arama: snippets/search-layer.liquid (predictive search + kacir()). */
document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ aramaKapat(); } });

function bultenGonder(e){
  e.preventDefault();
  var f=e.target, g=f.querySelector('input[type=email]');
  var v=(g&&g.value||'').trim();
  if(!v || v.indexOf('@')<1){ sepetBildir('Lütfen geçerli bir e-posta adresi yazın'); if(g) g.focus(); return false; }
  sepetBildir('Teşekkürler, listeye eklendiniz. Yeni ürünlerden ilk siz haberdar olacaksınız.');
  if(g) g.value='';
  return false;
}
function toggleMenu(){var d=document.getElementById('hdrDrawer');if(d)d.classList.toggle('open');}
function toggleBag(){var d=document.getElementById('bagDrawer');if(d)d.classList.toggle('open');}

(function(){
  /* 1 Eyl: secici 'body.home .topstack' idi — krom basliga gecince yapisma
     TUM sayfalara acildi. body'ye ts-stuck da yaziliyor: icerik sayfalarinda
     fixed'e gecisin yuttugu yuksekligi padding telafi eder (ana sayfada hero
     tam ekran, telafi istemez). --ts-h olcumu yapismadan ONCE alinir. */
  var ts=document.querySelector('.topstack');
  if(!ts)return;
  var ann=ts.querySelector('.announcement');
  var annH=0, tsOlculdu=false;
  function onScroll(){
    var y=window.pageYOffset;
    var stuck = y>annH+10;
    ts.classList.toggle('is-stuck', stuck);
    document.body.classList.toggle('ts-stuck', stuck);
  }
  /* 12 Oct 2026: heights come from ResizeObserver, which reports them after the
     browser's own layout, instead of reading offsetHeight while the page is still
     being laid out (Lighthouse "forced reflow"). It also follows the height change
     when the web fonts arrive, which the one-off measurement missed. */
  if('ResizeObserver' in window){
    new ResizeObserver(function(entries){
      var b=entries[0].borderBoxSize&&entries[0].borderBoxSize[0];
      var h=Math.round(b?b.blockSize:ts.offsetHeight);
      /* the stuck (fixed) bar has another height; keep the in-flow one */
      if(!tsOlculdu||!ts.classList.contains('is-stuck')){
        document.documentElement.style.setProperty('--ts-h', h+'px');
        tsOlculdu=true;
      }
    }).observe(ts);
    if(ann) new ResizeObserver(function(entries){
      var b=entries[0].borderBoxSize&&entries[0].borderBoxSize[0];
      annH=Math.round(b?b.blockSize:ann.offsetHeight);
      onScroll();
    }).observe(ann);
  } else {
    var olc=function(){
      if(!ts.classList.contains('is-stuck'))
        document.documentElement.style.setProperty('--ts-h', ts.offsetHeight+'px');
      annH=ann?ann.offsetHeight:0;
    };
    olc();
    window.addEventListener('resize',function(){olc();onScroll();});
  }
  window.addEventListener('scroll',onScroll,{passive:true});
  onScroll();
})();
(function(){
  var kutu=document.querySelector('body.home .hero__slides');
  if(!kutu)return;
  var slaytlar=kutu.querySelectorAll('.hero__bg');
  if(slaytlar.length<2)return;
  var noktalar=document.querySelectorAll('body.home .hero__dot');
  var i=0, sure=5000, zaman=null;
  function goster(n){
    if(window.yusoHeroYukle)window.yusoHeroYukle(); /* 12 Oct 2026: deferred slide images, see hero-slider.liquid */
    slaytlar[i].classList.remove('is-active');
    if(noktalar[i])noktalar[i].classList.remove('is-active');
    i=(n+slaytlar.length)%slaytlar.length;
    slaytlar[i].classList.add('is-active');
    if(noktalar[i])noktalar[i].classList.add('is-active');
  }
  function basla(){ durdur(); zaman=setInterval(function(){goster(i+1);}, sure); }
  function durdur(){ if(zaman){clearInterval(zaman); zaman=null;} }
  noktalar.forEach(function(d,n){ d.addEventListener('click',function(){goster(n); basla();}); });
  // sekme arka plandayken bosuna donmesin
  document.addEventListener('visibilitychange',function(){ document.hidden?durdur():basla(); });
  if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches) basla();
})();

